import { format, getMonth } from 'date-fns';
import React from 'react';

import ruLocale from 'date-fns/locale/ru';

import './showcase-lesson-teaser-card__dates.scss';

interface Props {
    from: Date;
    to: Date;
}

export const ShowcaseLessonTeaserCardDates = ({ from, to }: Props) => {
    const fromMonth = getMonth(from);
    const toMonth = getMonth(to);

    if (fromMonth !== toMonth) {
        const dates = [format(from, 'dd.MM', { locale: ruLocale }), format(to, 'dd.MM', { locale: ruLocale })].join(
            ' – '
        );

        return <div className="showcase-lesson-teaser-card__dates">{dates}</div>;
    }

    const days = [format(from, 'dd', { locale: ruLocale }), format(to, 'dd', { locale: ruLocale })].join('–');

    const month = format(to, 'MMMM', { locale: ruLocale });

    return (
        <>
            <div className="showcase-lesson-teaser-card__days">{days}</div>
            <div className="showcase-lesson-teaser-card__month">{month}</div>
        </>
    );
};
